import { render, staticRenderFns } from "./multipleChoicesExam.vue?vue&type=template&id=4e818454&"
import script from "./multipleChoicesExam.vue?vue&type=script&lang=js&"
export * from "./multipleChoicesExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports